import React from "react";
import "./ImageOverlay.css";
import ImageComponent from "../../../components/ImageComponent";
import { isImage } from "../../../util/Validator";
import clsx from "clsx";
import AutoPlayMutedVideo from "../../../components/AutoPlayMutedVideo";

interface ImageOverlayProps {
  imageSrc: string[] | string;
  size: number;
  isMiddleItem: boolean;
}
const ImageOverlay: React.FC<ImageOverlayProps> = ({
  imageSrc,
  size,
  isMiddleItem,
}) => {
  const isArray = Array.isArray(imageSrc);

  const isImages = isArray ? isImage(imageSrc[0]) : isImage(imageSrc);
  return (
    <div
      style={{
        width: size * 2.5,
        height: size * 2,
      }}
      className={clsx("image-lottie-container")}
    >
      <div
        className={clsx(
          "image-background-container",
          (!isImages || isMiddleItem) && "mask-video"
        )}
      >
        {isImages ? (
          <ImageComponent
            src={imageSrc}
            alt="Overlay"
            className={clsx(
              "background-image",
              isMiddleItem && "scale-middle-image"
            )}
          />
        ) : (
          <div className={clsx("bg-lottie-container")}>
            <AutoPlayMutedVideo
              videoSrc={isArray ? imageSrc[0] : imageSrc}
              classNameStyle="background-video"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageOverlay;
